import React from 'react';

import Table from 'components/Table';

import { formatDuration } from 'helpers/date';

const DoorEmployeesTable = ({ isLoading, ...props }) => (
  <Table
    loading={isLoading}
    rowKey="id"
    style={{ height: '100%' }}
    {...props}
  >
    <Table.Column type="link" title="Individual" dataIndex="name" to={({ item }) => `/individuals/${item.id}`} />
    <Table.Column type="datetime" title="Last seen" dataIndex="last_seen" tzOffset="timezone_offset" />
    <Table.Column title="Inbound processes" dataIndex="unloads_tot" align="right" />
    <Table.Column title="Outbound processes" dataIndex="loads_tot" align="right" />
    <Table.Column title="Total time seen" dataIndex="tot_mins_seen" align="right" render={totMins => {
      if (totMins === undefined || totMins === null) return '-';
      return formatDuration(totMins * 60 * 1000, false);
    }} />
  </Table>
);

export default DoorEmployeesTable;
